export default {
  namespaced: true,
  video_tour: {
    name: "Name",
    time_interval: "Time interval",
    time_interval_description: "Time interval in seconds",
    preview: "Preview",
    preview_message: "Click an item to see a preview.",
    success: "Video tour saved successfully",
    views_list: "List of views",
    selected_views: "Selected Views",
    items_selected: "Items selected",
    confirm_delete: "Are you sure to delete the video tour '%tour%'?",
    success_delete: "Video tour successfully deleted",
    layouts_list: "Layouts list"
  },
};
